import React from 'react'
import PropTypes from 'prop-types'
import ScheduleEditor from './RuleEditor'
import { buildScheduleCard } from '../summaries/scheduleCard'
import { useScheduleActions } from '../hooks/useScheduleActions'

const ScheduleList = ({
  entityOptions,
  study,
  disabled,
  showParticipantSession,
  instrumentName,
  onRemoveSchedule,
}) => {
  const { schedules, activeScheduleId, selectSchedule, addSchedule } = useScheduleActions()
  const currentId = activeScheduleId || schedules[0]?.id
  const activeIndex = Math.max(0, schedules.findIndex(schedule => schedule.id === currentId))
  const activeSchedule = schedules[activeIndex]

  return (
    <div className='se-schedule-list'>
      <section className='se-schedules-card'>
        <header className='se-rules-heading'>
          <h2>Deployment schedules</h2>
          <p className='se-help se-rules-inline-help'>
            An instrument can be deployed by several independent schedules. A participant sees the union of all of
            them.
          </p>
        </header>
        <div className='se-rule-tabs' role='tablist'>
          {schedules.map((schedule, index) => {
            const selected = schedule.id === currentId
            const card = buildScheduleCard(schedule, index, selected, entityOptions)
            return (
              <button
                key={schedule.id}
                type='button'
                role='tab'
                aria-selected={selected}
                className={`se-rule-tab${selected ? ' is-active' : ''}`}
                disabled={disabled}
                onClick={() => selectSchedule(schedule.id)}>
                {schedules.length > 1 ? (
                  <span
                    role='button'
                    tabIndex={0}
                    className='se-rule-tab-delete'
                    aria-label={`Delete ${card.kicker}`}
                    onClick={event => {
                      event.stopPropagation()
                      if (!disabled && onRemoveSchedule) onRemoveSchedule(schedule.id)
                    }}
                    onKeyDown={event => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault()
                        event.stopPropagation()
                        if (!disabled && onRemoveSchedule) onRemoveSchedule(schedule.id)
                      }
                    }}>
                    ×
                  </span>
                ) : null}
                <span className='se-rule-tab-kicker'>{card.kicker}</span>
                <strong className='se-rule-tab-kind'>{card.kind}</strong>
                {card.headline ? <span className='se-rule-tab-headline'>{card.headline}</span> : null}
                {card.meta ? <span className='se-rule-tab-meta'>{card.meta}</span> : null}
              </button>
            )
          })}
          <button
            type='button'
            className='se-rule-tab se-rule-tab-add'
            disabled={disabled}
            onClick={() => addSchedule()}>
            <span className='se-rule-tab-plus' aria-hidden>
              +
            </span>
            Add schedule
          </button>
        </div>
      </section>

      {activeSchedule ? (
        <>
          <div className='se-section-divider' aria-hidden />
          <section className='se-schedule-panel'>
            <h2 className='se-schedule-panel-title'>Schedule {activeIndex + 1}</h2>
            <ScheduleEditor
              schedule={activeSchedule}
              scheduleIndex={activeIndex}
              entityOptions={entityOptions}
              study={study}
              disabled={disabled}
              showParticipantSession={showParticipantSession}
              instrumentName={instrumentName}
            />
          </section>
        </>
      ) : null}
    </div>
  )
}

ScheduleList.propTypes = {
  entityOptions: PropTypes.object,
  study: PropTypes.object,
  disabled: PropTypes.bool,
  showParticipantSession: PropTypes.bool,
  instrumentName: PropTypes.string,
  onRemoveSchedule: PropTypes.func,
}

export default ScheduleList
